var _style, _path, _polygon, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEvrikaBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 739.4 207.1",
    style: {
      enableBackground: "new 0 0 739.4 207.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:14;stroke-miterlimit:10;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.1,7h621.2c28.8,0,52.1,23.3,52.1,52.1V148c0,28.8-23.3,52.1-52.1,52.1H59.1C30.3,200.1,7,176.7,7,148V59.1 C7,30.3,30.3,7,59.1,7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "444.6,66 419.7,83.6 424.9,48.3 447.2,48.3 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "408.8,158.7 431,158.7 443,76.7 418.1,95.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.7,89l2.5-17.4c0.8-5.4,3.8-6.9,8.9-6.9h56l9.6-16.6H92.7c-6.8,0-11.7,1.4-14.8,4.3 c-3.1,2.8-5,6.7-5.7,11.5l-11.5,78.4c-1.8,12.7,3.5,16.4,15.5,16.4H153l9.9-16.6H92.3c-4.1,0-6.6-0.4-7.5-1.3 c-1.3-1.2-1.2-3.1-0.9-4.7h-0.1l3.8-25.6h53.5l9.9-16.6H90L90.7,89L90.7,89L90.7,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.9,48.2l-48.4,89.4c-1.5,2.7-4.1,3.6-5.1,0l-22.2-89.4h-24.2l28.3,100c2.3,8,8.1,12,17.3,12 s16.2-4,20.9-12l57.5-100L271.9,48.2L271.9,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.4,48.2h-56.1c-12.9,0-20,6-21.9,18.8L285,158.9h22.3l5.9-40.4c10.2,0,14.4-0.8,19,4.5l33.6,35.9h28 l-39.2-39.1l0.1-0.8h15.2c22.3,0,29.9-17.1,32.7-36.4C405.7,61.2,400.3,48.2,376.4,48.2L376.4,48.2z M379.5,83.4 c-1.1,7.5-2.7,12.6-4.9,15.2c-2.7,3.3-7,4.9-12.9,4.9c-15.4,0-30.9,0-46.3,0l4.5-30.9c0.8-5.4,4.1-7.9,9.4-7.9h36.2 c6,0,10,1.1,12,3.3C379.9,70.7,380.6,75.8,379.5,83.4L379.5,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M652.7,59.4c-3-9.5-7.8-12.5-17.6-12.5c-10.8,0-15.8,3.3-21.3,12.5l-59.2,99.5h23.5l16.1-28h57l8.1,28h23.5 L652.7,59.4L652.7,59.4z M602.2,116l26-45.1c1.8-3.1,3.2-4.6,4-4.6s1.8,1.5,2.7,4.6l12.7,45.1H602.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.8,101.8c0.3-2.2,2.6-5,6.8-8.2l57.7-45.4h-27.5l-50.8,41.4c-0.3,0.3-0.6,0.6-1,0.8l6.2-42.3h-22.3 l-16.2,110.7h22.3l6.6-45.1c0.6,0.9,1.4,1.7,2.2,2.5l42.5,42.5h28.2l-49.1-46.7C500.2,108.3,498.4,104.8,498.8,101.8L498.8,101.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEvrikaBw);
export default __webpack_public_path__ + "static/media/Logo_Evrika_BW.31158b6c5b7405cd288b88010677d3ac.svg";
export { ForwardRef as ReactComponent };